/**
 * 批量下载
 * @param files
 * @returns {Promise<void>}
 */
import StreamSaver from "streamsaver";
import ZIP from "@/assets/js/zip-stream";
import {
	Message
} from 'element-ui';

export function batchDownload(nameZip, files) {
	console.log('files: ',files);
	files.forEach((item, index) => {
		item.name = index + 1 + '_' + item.name
	}) //对文件名重名处理
	let filename = nameZip + `${new Date().getTime()}.zip`;
	const zipFileOutputStream = StreamSaver.createWriteStream(filename)
	// 创建文件列表迭代
	const fileIterator = files.values();
	const readableZipStream = new ZIP({
		async pull(ctrl) {
			const fileInfo = fileIterator.next()
			if (fileInfo.done) { //迭代终止
				ctrl.close();
			} else {
				const {
					url,
					name
				} = fileInfo.value;
				return fetch(url).then(res => {
					ctrl.enqueue({
						name: name,
						stream: () => res.body
					});
				})
			}
		}
	});
	console.log('readableZipStream: ', readableZipStream);
	if (window.WritableStream && readableZipStream.pipeTo) {
		readableZipStream.pipeTo(zipFileOutputStream)
			.then(() =>
				Message({
					message: '下载完成',
					type: 'success'
				})
			)
	}
}

export function batchDownloadNest(nameZip, files) {
	console.log('batchDownloadNest', nameZip, files);
	// 存储下载的文件
	let downloadedFiles = [];
	
	// 下载单个文件
	async function downloadFile(file, index) {
		try {
			// updateFileStatus(index, '下载中', 'pending');
			const response = await fetch(file.url);
			if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
			const blob = await response.blob();
	
			// updateFileStatus(index, '已下载', 'downloaded');
			return {
				name: file.name,
				blob: blob,
				lastModified: new Date(),
				size: blob.size,
				pid: file.pid
			};
		} catch (error) {
			// updateFileStatus(index, '失败', 'error');
			throw error;
		}
	}
	
	// 下载所有文件
	async function downloadAllFiles() {
		console.log(2.1);
		// updateProgress(1, 5, '正在下载文件...');
	
		const downloadPromises = files.map((file, index) => downloadFile(file, index));
		downloadedFiles = await Promise.all(downloadPromises);
		console.log('downloadedFiles: ',downloadedFiles);
		// updateProgress(2, 5, '所有文件下载完成');
	}
	
	// 创建ZIP文件
	function createZipFile(zipFiles, zipName) {
		console.log('createZipFile', zipFiles, zipName);
		return new Promise((resolve, reject) => {
			const chunks = [];
	
			const writer = ZIP({
				start(controller) {
					// 将每个文件添加到ZIP
					zipFiles.forEach((file) => {
						controller.enqueue({
							name: file.name,
							lastModified: file.lastModified || new Date(),
							stream() {
								// 创建一个包含文件内容的可读流
								let offset = 0;
								const blob = file.blob;
	
								return new ReadableStream({
									pull(controller) {
										const chunk = blob.slice(offset, offset + 1024);
										if (chunk.size === 0) {
											controller.close();
											return;
										}
	
										return chunk.arrayBuffer().then((buffer) => {
											controller.enqueue(new Uint8Array(buffer));
											offset += chunk.size;
										});
									}
								});
							}
						});
					});
					controller.close();
				}
			});
	
			const reader = writer.getReader();
	
			function pump() {
				return reader
					.read()
					.then(({ value, done }) => {
						if (done) {
							const blob = new Blob(chunks, { type: 'application/zip' });
							resolve({
								name: zipName,
								blob: blob,
								lastModified: new Date(),
								
							});
							return;
						}
						chunks.push(value);
						return pump();
					})
					.catch(reject);
			}
	
			pump();
		});
	}
	
	// 嵌套压缩过程
	async function nestedCompression() {
		console.log(1.1);
		try {
			console.log(1.2);
			// 步骤1: 下载所有文件
			await downloadAllFiles();
			console.log(1.3);
			let arr = []
			let childZip = []
			let list = []
			
			arr = downloadedFiles.reduce((acc, current) => {
				// 查找是否已存在该pid的分组
				const existingGroup = acc.find(group => group[0].pid === current.pid);
				
				if (existingGroup) {
					// 如果存在，将当前项添加到该分组
					existingGroup.push(current);
				} else {
					// 如果不存在，创建新分组
					acc.push([current]);
				}
				
				return acc;
			}, []);
			console.log(1.4, arr);
			// 或者第二种方式：使用for循环
			for (let i = 0; i < arr.length; i++) {
			    if (arr[i].length > 1) {
			        // 步骤2: 压缩文件一和文件二
			        // updateProgress(3, 5, '正在压缩文件一和文件二...');
			        const zipFile = await createZipFile(arr[i], `files1-${i}.zip`);
					list.push(zipFile)
			    } else {
					list.push(arr[i][0])
				}
			}
			console.log(1.5, list);
	
			
	
			// 步骤3: 将第一个ZIP文件和文件三进行嵌套压缩
			// updateProgress(4, 5, '正在进行嵌套压缩...');
			const finalZipFile = await createZipFile(list, nameZip);
	
			// updateProgress(5, 5, '压缩完成，准备下载');
	
			// 创建下载链接
			const url = URL.createObjectURL(finalZipFile.blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = finalZipFile.name;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
	
			// statusMessage.textContent = '嵌套压缩文件已成功生成并开始下载！';
			// statusMessage.className = 'status-message success';
		} catch (error) {
			console.error('处理过程中出错:', error);
			// statusMessage.textContent = `处理过程中出错: ${error.message}`;
			// statusMessage.className = 'status-message error';
		} finally {
			// downloadBtn.disabled = false;
			// downloadBtn.textContent = '重新处理并下载';
		}
	}
	
	nestedCompression()
	
}